import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CallComponent} from './call.component';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {DirectivesModule} from '../../directives/directives.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    DirectivesModule,
  ],
  declarations: [
    CallComponent,
  ],
  exports: [
    CallComponent,
  ],
})
export class CallModule {
}
